"use client"

import { useState } from "react"
import type { ClassData } from "../../../../lib/classes-data"

interface ClassDetailsTabsProps {
  classData: ClassData
}

type TabType = "performance" | "subjects" | "activities"

export function ClassDetailsTabs({ classData }: ClassDetailsTabsProps) {
  const [activeTab, setActiveTab] = useState<TabType>("performance")

  return (
    <div className="text-gray-600 p-4 pt-0 text-sm">
      {/* Tab Navigation */}
      <div className="flex border-b border-gray-200 mb-4" role="tablist">
        <button
          onClick={() => setActiveTab("performance")}
          className={`px-3 py-2 text-xs focus:outline-none transition-colors ${
            activeTab === "performance"
              ? "text-[#21a193] border-b-2 border-[#21a193] font-semibold"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          Performance
        </button>
        {/* <button
          onClick={() => setActiveTab("subjects")}
          className={`px-3 py-2 text-xs focus:outline-none transition-colors ${
            activeTab === "subjects"
              ? "text-[#21a193] border-b-2 border-[#21a193] font-semibold"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          Subjects
        </button> */}
       
      </div>

      {/* Tab Content */}
      {activeTab === "performance" && (
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-gray-500">Top Performer</span>
            <span className="font-bold text-[#284e8c]">{classData.topPerformer}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-gray-500">Needs Support</span>
            <span className="font-bold text-red-500">{classData.needsSupport}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-gray-500">Average Sessions</span>
            <span className="font-bold text-gray-800">{classData.avgSessions}</span>
          </div>
          <div className="grid grid-cols-2 gap-2 mt-2">
            <div className="bg-green-100 p-2 rounded text-center">
              <span className="block text-lg font-bold text-green-700">{classData.excellentCount}</span>
              <span className="text-xs text-green-600">Excellent</span>
            </div>
            <div className="bg-orange-100 p-2 rounded text-center">
              <span className="block text-lg font-bold text-orange-700">{classData.strugglingCount}</span>
              <span className="text-xs text-orange-600">Struggling</span>
            </div>
          </div>
        </div>
      )}

      {activeTab === "subjects" && (
        <div className="grid grid-cols-2 gap-2">
          {classData.subjects.map((subject, index) => (
            <span
              key={index}
              className="px-2 py-1 bg-white rounded border border-gray-100 text-xs text-gray-700 text-center"
            >
              {subject}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}
